var _path, _path2, _circle, _rect, _path3, _rect2, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "innovation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.831,
    height: 111.831,
    viewBox: "0 0 111.831 111.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M165.882,42.446a34.947,34.947,0,1,0-54.605,28.9V81.762h39.316V71.343a34.912,34.912,0,0,0,15.289-28.9Z",
    transform: "translate(-75.019 -5.86)",
    fill: "#f5eeec"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M194.053,85.895V77.158H189.2a19.54,19.54,0,0,0-2.529-6.1l3.436-3.436-6.177-6.177-3.436,3.436a19.54,19.54,0,0,0-6.1-2.529V57.5h-8.737v4.855a19.54,19.54,0,0,0-6.1,2.529l-3.436-3.436-6.177,6.177,3.436,3.436a19.54,19.54,0,0,0-2.529,6.1H146v8.737h4.855a19.54,19.54,0,0,0,2.529,6.1l-3.436,3.436,6.177,6.177,3.436-3.436a19.54,19.54,0,0,0,6.1,2.529v4.855h8.737V100.7a19.54,19.54,0,0,0,6.1-2.529l3.436,3.436,6.177-6.177-3.436-3.436a19.54,19.54,0,0,0,2.529-6.1Z",
    transform: "translate(-114.111 -44.941)",
    fill: "#838fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 12.013,
    cy: 12.013,
    r: 12.013,
    transform: "translate(43.903 24.572)",
    fill: "#f83880"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 52.421,
    height: 6.553,
    rx: 3.276,
    transform: "translate(29.705 75.901)",
    fill: "#f83880"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M176,377.5h34.947v5.461a3.276,3.276,0,0,1-3.276,3.276H179.276A3.276,3.276,0,0,1,176,382.961Z",
    transform: "translate(-137.558 -295.046)",
    fill: "#838fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 34.947,
    height: 8.737,
    rx: 4.368,
    transform: "translate(38.442 91.191)",
    fill: "#838fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M216,457.5h17.474v6.989a3.276,3.276,0,0,1-3.276,3.276H219.276A3.276,3.276,0,0,1,216,464.489Z",
    transform: "translate(-168.821 -357.573)",
    fill: "#f83880"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M451.633,99.008a1.629,1.629,0,0,0,.692-.155l5.345-2.492a1.638,1.638,0,1,0-1.385-2.968l-5.345,2.492a1.638,1.638,0,0,0,.692,3.123Z",
    transform: "translate(-351.705 -72.861)",
    fill: "#053544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M457.555,217.885l-5.345-2.492a1.638,1.638,0,1,0-1.385,2.968l5.345,2.492a1.638,1.638,0,1,0,1.385-2.968Z",
    transform: "translate(-351.59 -168.214)",
    fill: "#053544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M477.536,160h-5.9a1.638,1.638,0,1,0,0,3.276h5.9a1.638,1.638,0,1,0,0-3.276Z",
    transform: "translate(-367.342 -125.053)",
    fill: "#053544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M30.084,95.885,24.74,93.393a1.638,1.638,0,1,0-1.385,2.968L28.7,98.853a1.638,1.638,0,1,0,1.385-2.968Z",
    transform: "translate(-17.488 -72.861)",
    fill: "#053544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M28.7,215.393l-5.345,2.492a1.638,1.638,0,1,0,1.385,2.968l5.345-2.492a1.638,1.638,0,1,0-1.385-2.968Z",
    transform: "translate(-17.488 -168.214)",
    fill: "#053544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M9.174,161.638A1.638,1.638,0,0,0,7.536,160h-5.9a1.638,1.638,0,1,0,0,3.276h5.9a1.638,1.638,0,0,0,1.638-1.638Z",
    transform: "translate(0 -125.053)",
    fill: "#053544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M185.4,88.407l-2.54-2.54a21.068,21.068,0,0,0,1.747-4.2h3.582a1.638,1.638,0,0,0,1.638-1.638V71.3a1.638,1.638,0,0,0-1.638-1.638H184.6a21.069,21.069,0,0,0-1.747-4.2l2.54-2.54a1.636,1.636,0,0,0,0-2.315l-6.17-6.179a1.636,1.636,0,0,0-2.315,0l-2.54,2.54a21.069,21.069,0,0,0-4.2-1.747V51.638A1.638,1.638,0,0,0,168.533,50H159.8a1.638,1.638,0,0,0-1.638,1.638v3.591a21.068,21.068,0,0,0-4.2,1.747l-2.54-2.549a1.636,1.636,0,0,0-2.315,0l-6.179,6.179a1.636,1.636,0,0,0,0,2.315l2.54,2.54a21.069,21.069,0,0,0-1.747,4.2h-3.582A1.638,1.638,0,0,0,138.5,71.3v8.737a1.638,1.638,0,0,0,1.638,1.638h3.591a21.069,21.069,0,0,0,1.747,4.2l-2.54,2.54a1.636,1.636,0,0,0,0,2.315l6.179,6.179a1.636,1.636,0,0,0,2.315,0l2.54-2.54a21.07,21.07,0,0,0,4.2,1.747v3.582a1.638,1.638,0,0,0,1.629,1.638h8.737a1.638,1.638,0,0,0,1.638-1.638V96.1a21.068,21.068,0,0,0,4.2-1.747l2.54,2.54a1.636,1.636,0,0,0,2.315,0l6.179-6.179A1.636,1.636,0,0,0,185.4,88.407Zm-5.753-1.12,2.278,2.278-3.862,3.862-2.278-2.278a1.636,1.636,0,0,0-2.031-.218,17.862,17.862,0,0,1-5.585,2.317,1.638,1.638,0,0,0-1.276,1.6v3.206h-5.461V94.835a1.638,1.638,0,0,0-1.276-1.6,17.862,17.862,0,0,1-5.585-2.315,1.636,1.636,0,0,0-2.031.218l-2.278,2.278L146.4,89.556l2.278-2.278a1.636,1.636,0,0,0,.218-2.031,17.863,17.863,0,0,1-2.315-5.585,1.638,1.638,0,0,0-1.6-1.276h-3.209V72.934h3.217a1.638,1.638,0,0,0,1.6-1.276,17.862,17.862,0,0,1,2.315-5.585,1.636,1.636,0,0,0-.218-2.031l-2.278-2.278,3.862-3.862,2.278,2.278a1.636,1.636,0,0,0,2.031.218,17.862,17.862,0,0,1,5.585-2.315,1.638,1.638,0,0,0,1.276-1.6V53.276H166.9v3.217a1.638,1.638,0,0,0,1.276,1.6,17.862,17.862,0,0,1,5.585,2.315,1.636,1.636,0,0,0,2.031-.218l2.278-2.278,3.862,3.862-2.278,2.278a1.636,1.636,0,0,0-.218,2.031,17.863,17.863,0,0,1,2.315,5.585,1.638,1.638,0,0,0,1.6,1.276h3.2V78.4h-3.217a1.638,1.638,0,0,0-1.6,1.276,17.863,17.863,0,0,1-2.315,5.585,1.636,1.636,0,0,0,.227,2.023Z",
    transform: "translate(-108.249 -39.079)",
    fill: "#053544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M207.151,105A13.651,13.651,0,1,0,220.8,118.651,13.651,13.651,0,0,0,207.151,105Zm0,24.026a10.375,10.375,0,1,1,10.375-10.375A10.375,10.375,0,0,1,207.151,129.026Z",
    transform: "translate(-151.236 -82.066)",
    fill: "#053544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M161.671,36.585A36.585,36.585,0,1,0,103.79,66.337v7.926h-1.638a4.914,4.914,0,1,0,0,9.829h3.822v3.822a4.893,4.893,0,0,0,1.256,3.276,4.893,4.893,0,0,0-1.256,3.276v2.184a4.919,4.919,0,0,0,4.914,4.914h3.822v5.351a4.919,4.919,0,0,0,4.914,4.914h10.921a4.919,4.919,0,0,0,4.914-4.914v-5.351h3.822a4.919,4.919,0,0,0,4.914-4.914V94.467a4.893,4.893,0,0,0-1.256-3.276,4.893,4.893,0,0,0,1.256-3.276V84.092h3.822a4.914,4.914,0,0,0,0-9.829h-1.638V66.336a36.59,36.59,0,0,0,15.289-29.751Zm-29.487,70.331a1.638,1.638,0,0,1-1.638,1.638H119.625a1.638,1.638,0,0,1-1.638-1.638v-5.351h14.2Zm8.737-10.266a1.638,1.638,0,0,1-1.638,1.638H110.888a1.638,1.638,0,0,1-1.638-1.638V94.467a1.638,1.638,0,0,1,1.638-1.638h28.395a1.638,1.638,0,0,1,1.638,1.638Zm0-8.737a1.638,1.638,0,0,1-1.638,1.638H110.888a1.638,1.638,0,0,1-1.638-1.638V84.092h31.671Zm8.737-8.737a1.638,1.638,0,0,1-1.638,1.638H102.151a1.638,1.638,0,0,1,0-3.276H148.02a1.638,1.638,0,0,1,1.638,1.638Zm-42.592-4.914V65.482a1.64,1.64,0,0,0-.716-1.354,33.309,33.309,0,1,1,37.473,0,1.64,1.64,0,0,0-.717,1.355v8.781Z",
    transform: "translate(-69.17)",
    fill: "#053544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M237.682,145.509l-4.919,5.273-1.415-1.516a1.641,1.641,0,0,0-2.4,2.237l2.621,2.8a1.638,1.638,0,0,0,2.4,0l6.116-6.553a1.641,1.641,0,0,0-2.4-2.237Z",
    transform: "translate(-178.595 -113.318)",
    fill: "#053544"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.d69b0802e272d0c064e7f6443509c62d.svg";
export { ForwardRef as ReactComponent };